import { SxProps } from '@mui/system'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import { theme } from 'src/providers/ThemeProvider'

type InfoBarElements = {
  container: SxProps
  closeButton: SxProps
}

const COLOR = theme.colors.gray14

function getBackgroundColor(type: string): string {
  switch (type) {
    case AlertType.SUCCESS:
      return theme.colors.seaGreen050
    case AlertType.ERROR:
      return theme.colors.persianRed050
    case AlertType.WARNING:
      return theme.colors.saffron050
    case AlertType.INFO:
      return theme.colors.byzantineBlue050
    default:
      return theme.colors.byzantineBlue050
  }
}

export function getInfoIconColor(type: string): string {
  switch (type) {
    case AlertType.SUCCESS:
      return theme.colors.seaGreen200
    case AlertType.ERROR:
      return theme.colors.persianRed100
    case AlertType.WARNING:
      return theme.colors.saffron200
    default:
      return theme.colors.byzantineBlue200
  }
}

export const infoBarStyles = (type: string): InfoBarElements => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    color: COLOR,
    padding: '8px 12px',
    borderRadius: '4px',
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',

    '&.MuiPaper-root.MuiAlert-standardSuccess': {
      backgroundColor: getBackgroundColor(type),
      color: COLOR,
      minHeight: '38px',
      height: 'auto'
    },

    '& .MuiAlert-message': {
      flex: '1 1 auto',
      opacity: 1,
      padding: '2px 0',

      '& p': {
        padding: 0,
        margin: 0
      }
    },

    '& .MuiAlert-icon': {
      opacity: 1,
      marginRight: '8px'
    },

    '& .MuiAlert-action': {
      flex: '0 0 auto',
      marginRight: 0,

      '& .MuiButtonBase-root': {
        padding: '2px',
        fontSize: '16px'
      }
    }
  },

  closeButton: {
    color: COLOR
  }
})
